import { RouteObject } from "../../interfaces/navigation";
import React from "react";

const EntryPoint = React.lazy(() => import("../../containers/Servicios/ServiciosContainer"));

export const serviciosRoutes: RouteObject[] = [
    {
        title: "Servicios",
        path: "/servicios",
        component: <EntryPoint/>
    }
];